import React, { useEffect } from 'react'

const HtmlRawContainerArticle = ({ articleObj }) => {
  useEffect(() => {
    handleVideo()
    handleHsForm()
  }, [])
  function handleVideo() {
    const head = document.querySelector("#videoUrl");
    const scriptTagId = document.querySelectorAll("#multiVideo");
    let url;

    if (scriptTagId) {
      for (let i = 0; i < scriptTagId.length; i++) {
        const script = document.createElement("script");
        url = scriptTagId[i].getAttribute("src");
        if (url) {
          script.setAttribute("src", url);
          script.setAttribute("id", "customId");
          head.appendChild(script);
        }
      }
    }
    return () => {
      const scriptTag = document.querySelectorAll("#customId");
      if (scriptTag) {
        for (let i = 0; i < scriptTag.length; i++) {
          head.removeChild(scriptTag[i]);
        }
      };
    }
  }
  function handleHsForm() {
    // const head = document.querySelector("head");
    // const scriptTagId = document.querySelectorAll("#ose-hs-form-id");

    // if (scriptTagId) {
    //   for (let i = 0; i < scriptTagId.length; i++) {
    //     let script = document.createElement("script");
    //     script = scriptTagId[i]
    //     console.log("script", script);
    //     script.setAttribute("id", "customFormId");
    //     head.appendChild(script);
    //   }
    // }
    // return () => {
    //   const scriptTag = document.querySelectorAll("#customFormId");
    //   if (scriptTag) {
    //     for (let i = 0; i < scriptTag.length; i++) {
    //       head.removeChild(scriptTag[i]);
    //     }
    //   };
    // }
    const hsClass = document.querySelector(".ngssebook-copy");

    if (hsClass) {
      var portalId = hsClass.getAttribute("portalId");
      var formId = hsClass.getAttribute("formId");
      var region = hsClass.getAttribute("region");
      var height = hsClass.getAttribute("height");
      var hubUrl = hsClass.getAttribute("hubSpotUrl");
      var hubSpotUrl = `/${hubUrl ? hubUrl : "hubSpot"}?portalId=${portalId ? portalId : "44059706"}&formId=${formId ? formId : "369d68d2-7993-4ddc-91ad-46914ae7f1d7"}&region=${region ? region : "nal"}`


      hsClass.innerHTML = ` <iframe className="pdpHubspotForm" scrolling="no" style="width: 100%;height: ${height ? height : "1018px"}"  src=${hubSpotUrl} />`;

    }
  }
  return (
    <div className={`${articleObj.attributes.articleRendering} ${articleObj.attributes.class}`}>
      <span className='html-raw-content-page' dangerouslySetInnerHTML={{ __html: articleObj.attributes.htmlRawContent }}></span>
    </div>
  )
}

export default HtmlRawContainerArticle
